import { memo, useMemo } from "react";
import Box from "@mui/material/Box";
import Image from "next/image";
import CustomText from "./text";
import { colors } from "@/utils/const";

const BASE_CARD_SX = {
  color: "#fff",
  borderRadius: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 1,
  boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
  padding: "18px",
  minHeight: "135px",
};

function CardWithIcon({ icon, content, bgColor = "#282781" }) {
  const cardSx = useMemo(() => ({ ...BASE_CARD_SX, backgroundColor: bgColor }), [
    bgColor,
  ]);

  return (
    <Box sx={cardSx}>
      <Image
        src={icon}
        alt={content}
        width={36}
        height={36}
        // helps Next serve correct image sizes
        sizes="36px"
        loading="lazy"
      />

      <CustomText
        text={content}
        type="sm"
        customStyle={{ color: colors.white }}
      />
    </Box>
  );
}

export default memo(CardWithIcon);
